export const typeDefs = `
  union OtherPlatformsTrxListSortType = date | platformName | trxId | trxType | trxFlowType | amountUsd | amountMbtc

  input OtherPlatformsTrxListFilterInput {
    date: [String]
    platformName: String
    trxId: String
    trxFlowType: String
    trxType: String
    amountMbtc: [Float]
    amountUsd: [Float]
  }
`;
